import React from "react";
import "./AgentsSection.css";

interface AgentCardProps {
  title: string;
  subtitle: string;
  description: string;
  bullets: string[];
  buttonText: string;
  onButtonClick?: () => void;
  gradient: string;
  iconColor: string;
  textColor?: string;
  darkButton?: boolean;
}

const AgentCard: React.FC<AgentCardProps> = ({
  title,
  subtitle,
  description,
  bullets,
  buttonText,
  onButtonClick,
  gradient,
  iconColor,
  textColor = "#0A0F1C",
  darkButton = false,
}) => {
  return (
    <div className="agent-card" style={{ background: gradient, color: textColor }}>
      {/* Dynamic Orb Icon */}
      <div
        className="agent-icon"
        style={{ "--icon-color": iconColor } as React.CSSProperties}
      ></div>

      <h3>{title}</h3>
      <p className="subtitle">{subtitle}</p>
      <p className="description">{description}</p>

      <ul>
        {bullets.map((b, i) => (
          <li key={i}>{b}</li>
        ))}
      </ul>

      <button
        className={`agent-btn ${darkButton ? "dark" : ""}`}
        onClick={onButtonClick}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default AgentCard;
